import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon AddressBookIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const AddressBookIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M7.47876 1.59302C10.2627 -0.0706749 13.7358 -0.0705532 16.5198 1.59302C20.9379 4.23356 22.1625 10.0829 19.1741 14.2737L12.7649 23.261C12.3899 23.7867 11.6086 23.7868 11.2336 23.261L4.82446 14.2737C1.83634 10.083 3.06086 4.23358 7.47876 1.59302ZM16.0071 2.45142C13.5389 0.976478 10.4595 0.976356 7.99146 2.45142C4.07498 4.79229 2.99006 9.97756 5.63892 13.6926L11.9993 22.6116L18.3596 13.6926C21.0087 9.97747 19.9238 4.79228 16.0071 2.45142ZM12.0989 6.50024C14.0859 6.50052 15.6973 8.11192 15.6975 10.0989C15.6973 12.0858 14.0859 13.6963 12.0989 13.6965C10.1116 13.6965 8.50049 12.086 8.50024 10.0989C8.50043 8.11175 10.1116 6.50024 12.0989 6.50024ZM12.0989 7.50024C10.6638 7.50024 9.50043 8.66417 9.50024 10.0989C9.50049 11.5335 10.6638 12.6965 12.0989 12.6965C13.5337 12.6963 14.6973 11.5334 14.6975 10.0989C14.6973 8.66433 13.5338 7.50052 12.0989 7.50024Z"
        fill="#503291"
      />
    </Icon>
  )
}
export default AddressBookIcon
